import React, { useEffect } from 'react'
import { HiOutlineDocumentDuplicate } from 'react-icons/hi2'
import { MdOutlineLibraryBooks } from 'react-icons/md'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import PageTitle from '../../../../components/partials/PageTitle'
import { resetCustomerOverviewData } from '../../../../redux/slice/report/reportSlice'
import { BsCashStack } from 'react-icons/bs'
import { GiReceiveMoney } from 'react-icons/gi'


const customerReports = [
    {name: 'Policy Information',icon: <HiOutlineDocumentDuplicate size={26}/>, link: '/admin/reports/policy-report/policy-information', permission: 'customer policy information report'},
    {name: 'Policy Expiry/ Renewal Date',icon: <MdOutlineLibraryBooks size={26} />, link: '/admin/reports/policy-report/policy-expiry', permission: 'customer policy expiry-renewal date report'},
    {name: 'Renewed Policy',icon: <MdOutlineLibraryBooks size={26} />, link: '/admin/reports/policy-report/renewed-policy', permission: 'customer policy expiry-renewal date report'},
    {name: 'Claims Report',icon: <GiReceiveMoney size={26}/>, link: '/admin/reports/claim-report', permission: 'customer report module'},
    {name: 'Premium Report',icon: <BsCashStack size={26}/>, link: '/admin/reports/customer-payment', permission: 'customer premuin payment report'},
]
const PolicyReport = () => {

    const { user_permissions } = useSelector((state) => state?.auth?.user);

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const breadcrumb = {
        from: {
          title: "Reports",
          link: "/admin/reports",
        },
        current: {
          title: "Policy Report",
          link: null,
        },
      };

    useEffect(() => {
      dispatch(resetCustomerOverviewData())
    }, [dispatch])

    const filteredReports = customerReports.filter((item) => {
      return user_permissions?.some((permission) => permission.name === item.permission);
    });
    
    useEffect(() => {
      if (!user_permissions?.some(permission => permission.name === 'customer report module')) {
        navigate('/admin/dashboard')
      }
    }, [navigate, user_permissions])
  return (
    <>
        {/* page title */}
        <PageTitle title='Policy Report' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row gap-4 p-1 mt-2' style={{ margin: "auto 1px" }}>
            {filteredReports.map((item, i) => (
                <Link to={item?.link} className='col-3 card p-3 hover-primary' key={i}>
                    <div className=' d-flex gap-2 flex-column  align-items-center'>
                        <div>
                            <span className='icon-primary'>{item?.icon}</span>
                        </div>
                        <div>
                            <p>{item?.name}</p>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    </>
  )
}

export default PolicyReport